import { fetchPageData } from "../utils/fetch";

export const getConferences = async () => {
  const endpoint = "conferences";
  const method = "GET";
  const err = "Failed to fetch conferences.";
  const fetchedData = await fetchPageData(endpoint, method, err);
  return fetchedData;
};

export const updateConference = async (token, conferenceId, conferenceData) => {
  const endpoint = conferenceId ? `conference/${conferenceId}` : "conference";
  const err = conferenceId
    ? "Editing conference failed."
    : "Creating conference failed.";
  const method = conferenceId ? "PUT" : "POST";
  const fetchedData = await fetchPageData(
    endpoint,
    method,
    err,
    token,
    conferenceData
  );
  return fetchedData;
};

export const deleteConference = async (token, conferenceId) => {
  const endpoint = `conference/${conferenceId}`;
  const method = "DELETE";
  const err = "Deleting conference failed.";
  const fetchedData = await fetchPageData(endpoint, method, err, token);
  return fetchedData;
};
